import { Alert, Button, Card, Col, Form, Input, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { authSelector } from "../../feature/auth/authSelector";
import { resetPasswordRequest } from "../../feature/auth/authSlice";
import usePrevious from "../../hooks/usePrevious";

const { Header, Content } = Layout;

const ResetPassword = () => {
  const [message, setMesssage] = useState("");
  const { errorMessage, isResetPassword } = useSelector(({ authState }) =>
    authSelector(authState)
  );
  const dispatch = useDispatch();

  const { codes } = useParams();
  const [form] = Form.useForm();
  const prevIsResetPassword = usePrevious(isResetPassword);

  const onFormFinish = (values) => {
    dispatch(
      resetPasswordRequest({
        password: values.password,
        confirmPassword: values.confirmPassword,
        resetPasswordCode: codes,
      })
    );
  };

  const onChange = () => {
    setMesssage(null);
  };

  useEffect(() => {
    if (prevIsResetPassword && !isResetPassword) {
      if (errorMessage) {
        setMesssage({ text: errorMessage.text, type: errorMessage.type });
      } else {
        setMesssage({
          text: (
            <div>
              Your password is reset, you can try <Link to="/login">login</Link>{" "}
              again.
            </div>
          ),
          type: "success",
        });
      }
    }
  }, [isResetPassword]);

  return (
    <Layout className="layout-default layout-reset-password">
      <Header className="flex-center">
        <div className="header-col header-brand">
          <h5>Asinzen Referral Portal</h5>
        </div>
      </Header>
      <Content>
        <Row className="box">
          <Col xs={12} lg={10}>
            <Card
              size="small"
              title={
                <>
                  <h1 className="title-reset-password">
                    Create a new Password
                  </h1>
                  <div>Type to confirm a new password for the account</div>
                </>
              }
            >
              {message && <Alert message={message.text} type={message.type} />}
              <Form
                form={form}
                name="form"
                layout="vertical"
                onFinish={onFormFinish}
              >
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!",
                    },
                  ]}
                >
                  <Input.Password
                    autoComplete="new-password"
                    onChange={onChange}
                  />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  label="Confirm Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your confirm password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The confirm password that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password autoComplete="off" onChange={onChange} />
                </Form.Item>
                <Form.Item>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    htmlType="submit"
                    loading={isResetPassword}
                  >
                    Reset your password
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ResetPassword;
